import {
	Box,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	FormControl,
	FormControlLabel,
	FormGroup,
	FormLabel,
	IconButton,
	LinearProgress,
	MenuItem,
	TextField,
	Typography,
	RadioGroup,
	Select,
	Switch,
	Radio,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveTipoActParte } from "../../../services/TipoActParteService";

const initialState = {
	descripcion: "",
	descripcionCorta: "",
	validoDemanda: false,
	validoDesarchivo: false,
	tipoDocumentacion: "documento-adjunto",
	observaciones: "",
};

const itemGender = "M";
const nameItemText = "Tipo de Actuación de Parte";

//
// #####################################################################################################################  
//
const TipoActParteDialog = ({
	onSave,
	onClose,
	itemCrud,
	actionCrud,
	setMessage,
	setShowMessage,
}) => {
	const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
	const [isDoingSomething, setIsDoingSomething] = useState(false);


	useEffect(() => {
		if (actionCrud === "create") {
			setItemCrudLocal(initialState);
		} else {
			setItemCrudLocal(itemCrud);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps 
	}, []);

	const handleCloseDialog = () => {
		onClose();
	};

	const handleChange = (e) => {
		setItemCrudLocal({
			...itemCrudLocal,
			[e.target.name]:
				e.target.type === "checkbox" ? e.target.checked : e.target.value,
		});
	};


	const handleSave = () => {

		if (actionCrud === "create" || actionCrud === "update") {

			if (itemCrudLocal.descripcion.trim() === "") {
				setMessage({
					severity: "error",
					messageText: "Debes ingresar una descripción",
				});
				setShowMessage(true);
				return;
			}
		}

		if (actionCrud === "create") {
			if (itemCrudLocal.descripcionCorta.trim() === "") {
				setMessage({
					severity: "error",
					messageText: "Debes ingresar una descripción corta",
				});
				setShowMessage(true);
				return;
			}
		}

		save();
	};

	const save = async () => {
		let _itemCrud = {
			descripcion: itemCrudLocal.descripcion,
			validoDemanda: itemCrudLocal.validoDemanda,
			validoDesarchivo: itemCrudLocal.validoDesarchivo,
			tipoDocumentacion: itemCrudLocal.tipoDocumentacion,
			observaciones: itemCrudLocal.observaciones,
			usernameUsuarioActualiza: localStorage.getItem("emailUsuario"),
		};
		if (actionCrud !== "create") {
			_itemCrud.id = itemCrudLocal.id;
		}
		if (actionCrud === "create") {
			_itemCrud.descripcionCorta = itemCrudLocal.descripcionCorta;
		}

		setIsDoingSomething(true);
		const response = await saveTipoActParte(actionCrud, _itemCrud);
		setIsDoingSomething(false);

		if (response.ok) {
			onSave();
		}

		setMessage({
			messageText: response.messageText,
			severity: response.messageSeverity,
		});
		setShowMessage(true);
	};

	return (
		<>
			<Dialog
				open={true}
				onClose={handleCloseDialog}
				maxWidth="md"
				fullWidth={true}
				scroll="paper"
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title"
					textAlign={{ xs: "center", sm: "center" }}

				>
					{actionCrud === "create"
						? itemGender === "M"
							? "Nuevo"
							: "Nueva"
						: actionCrud === "update"
							? "Editando"
							: actionCrud === "enable"
								? "Habilitando"
								: actionCrud === "read"
									? "Detalle"
									: "Deshabilitando"}{" "}
					{nameItemText}
					<IconButton
						aria-label="close"
						onClick={handleCloseDialog}
						sx={{
							position: "absolute",
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>

				{isDoingSomething && <LinearProgress />}

				<DialogContent dividers>
					<Box sx={{ m: 1, p: 1 }}>
						<TextField
							variant="outlined"
							size="small"
							name="descripcion"
							label="Descripción"
							value={itemCrudLocal.descripcion}
							onChange={handleChange}
							disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read"}
							sx={{ width: "100%", pb: 1 }}
							inputProps={{ maxLength: 80 }}
						/>

						<TextField
							variant="outlined"
							size="small"
							name="descripcionCorta"
							label="Descripción corta"
							value={itemCrudLocal.descripcionCorta}
							onChange={handleChange}
							disabled={actionCrud === "disable" || actionCrud === "update" || actionCrud === "enable" || actionCrud === "read"}
							sx={{ width: "100%", pb: 1 }}
							inputProps={{ maxLength: 80 }}
						/>

						<FormControl component="fieldset"
							disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read" || itemCrudLocal.tipoDocumentacion === "texto-simple"}>
							<FormLabel component="legend">Válido para presentar inicio de demanda</FormLabel>
							<FormGroup aria-label="position" row>
								<FormControlLabel
									control={<Switch color="primary" />}
									labelPlacement="right"
									onChange={handleChange}
									checked={itemCrudLocal.tipoDocumentacion === "texto-simple" ? false :
										itemCrudLocal.validoDemanda
									}
									name="validoDemanda"
								/>
							</FormGroup>
						</FormControl>

						<div style={{ height: "10px" }}></div>

						<FormControl component="fieldset"
							disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read"}>
							<FormLabel component="legend">Válido para solicitar desarchivo de expediente</FormLabel>
							<FormGroup aria-label="position" row>
								<FormControlLabel
									control={<Switch color="primary" />}
									labelPlacement="right"
									onChange={handleChange}
									name="validoDesarchivo"
									checked={itemCrudLocal.validoDesarchivo}
								/>
							</FormGroup>
						</FormControl>

						<div style={{ height: "10px" }}></div>

						<Typography variant="subtitle1" component="span" >
							Tipo de Documentación
						</Typography>
						<RadioGroup
							row
							aria-labelledby="tipo-documentacion-radio-buttons-group-label"
							name="tipoDocumentacion"
							value={itemCrudLocal.tipoDocumentacion ? itemCrudLocal.tipoDocumentacion : ""}
							onChange={handleChange}
						>
							<FormControlLabel value="documento-adjunto" control={<Radio />} label="Documento Adjunto" disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read"} />
							<FormControlLabel value="texto-simple" control={<Radio />} label="Texto Simple" disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read"} />
						</RadioGroup>
						{/* <Select
							variant="outlined"
							size="small"
							name="tipoDocumentacion"
							value={itemCrudLocal.tipoDocumentacion ? itemCrudLocal.tipoDocumentacion : ""}
							onChange={handleChange}
							disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read"}
							sx={{ width: "100%", pb: 1 }}
						>
							<MenuItem value="documento-adjunto">Documento Adjunto</MenuItem>
							<MenuItem value="texto-simple">Texto Simple</MenuItem>
						</Select> */}

						<div style={{ height: "10px" }}></div>

						<TextField
							variant="outlined"
							size="small"
							name="observaciones"
							label="Observaciones"
							value={itemCrudLocal.observaciones}
							onChange={handleChange}
							disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read"}
							sx={{ width: "100%", pb: 1 }}
							inputProps={{ maxLength: 80 }}
						/>

						{actionCrud !== "create" && (
							<Box
								sx={{
									p: 1,
									mt: 1,
									color: "SlateGrey",
									border: "0px solid DarkGray",
									borderRadius: "3px",
								}}
							>
								<Typography variant="h8" component="div" gutterBottom>
									Creado: {itemCrudLocal.fechaCreacion}
								</Typography>

								<Typography variant="h8" component="div" gutterBottom>
									Última actualización: {itemCrudLocal.fechaActualizacion}
								</Typography>

								<Typography variant="h8" component="div" gutterBottom>
									Último usuario que actualizó: {itemCrudLocal.nombreUsuario}{" "}
									{itemCrudLocal.apellidoUsuario} ({itemCrudLocal.username})
								</Typography>
							</Box>
						)}
					</Box>

					<Box sx={{ textAlign: "right" }}>
						<Button
							sx={{ mr: 1 }}
							variant="outlined"
							onClick={handleCloseDialog}
							startIcon={<CloseIcon />}
						>
							Cancelar
						</Button>

						{(actionCrud !== "read") && (
							<Button
								sx={{ mr: 1, backgroundcolor: "warning" }}
								variant="contained"
								onClick={handleSave}
								startIcon={
									actionCrud === "disable" ? (
										<RemoveCircleOutlineIcon />
									) : actionCrud === "enable" ? (
										<AddCircleOutlineIcon />
									) : (
										<SaveIcon />
									)
								}
							>
								{actionCrud === "disable"
									? "Deshabilitar"
									: actionCrud === "enable"
										? "Habilitar"
										: "Guardar"}
							</Button>
						)}
					</Box>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default TipoActParteDialog;
